export interface TreeNode {
  id: string;
  path: string;
  parentPath?: string;
  name: string;
  type: 'file' | 'folder';
  expanded?: boolean;
  isEditable: boolean;
  isDeletable: boolean;
  version?: string;
  children?: TreeNode[];
  ext?:
    | '.doc'
    | '.docx'
    | '.html'
    | '.txt'
    | '.csv'
    | '.xls'
    | '.xlsx'
    | '.pdf'
    | '.dwg'
    | '.json'
    | '.geojson'
    | '.shp'
    | '.prj'
    | '.dbf'
    | '.shx'
    | '.zip'
    | '.jpg'
    | '.jpeg'
    | '.png';
}

export interface Icon {
  class?: string;
  type?: 'file' | 'folder';
  icon: string;
  tooltip?: string;
  ext?:
    | '.doc'
    | '.docx'
    | '.html'
    | '.txt'
    | '.csv'
    | '.xls'
    | '.xlsx'
    | '.pdf'
    | '.dwg'
    | '.json'
    | '.geojson'
    | '.shp'
    | '.prj'
    | '.dbf'
    | '.shx'
    | '.zip'
    | '.jpg'
    | '.jpeg'
    | '.png'
    | '.php'
    | '.dxf';
}

export interface Breadcrumb {
  name: string;
  visible: boolean;
}

export const ITEMSICON: Icon[] = [
  {
    icon: 'folder',
    type: 'folder',
    class: 'fe-icon color-yellow lh-1'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.doc'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.docx'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.html'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.txt'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.csv'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.xls'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.xlsx'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.pdf'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.dwg'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.json'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.geojson'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.shp'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.dbf'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.prj'
  },
  {
    icon: 'description',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.shx'
  },
  {
    icon: 'folder_zip',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.zip'
  },
  {
    icon: 'image',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.jpg'
  },
  {
    icon: 'image',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.png'
  },
  {
    icon: 'image',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.jpeg'
  },
  {
    icon: 'image',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.php'
  },
  {
    icon: 'image',
    type: 'file',
    class: 'fe-icon color-blu lh-1',
    ext: '.dxf'
  }
];
